import { render, staticRenderFns } from "./CustomerMilkReceipt.vue?vue&type=template&id=a52c486e&scoped=true&"
import script from "./CustomerMilkReceipt.vue?vue&type=script&lang=js&"
export * from "./CustomerMilkReceipt.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMilkReceipt.vue?vue&type=style&index=0&id=a52c486e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c486e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VCombobox,VContainer,VIcon,VRow})
